import { setSelectedE9Roles } from "../slice/docFlowSlice";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const selectE9RoleThunk = createAsyncThunk("select/e9-roles", (value, {dispatch, getState}) => {
    const allE9Roles = getState().documentFlow.allE9Roles;
    const selectedRole = allE9Roles.find((role) => parseInt(role.UserRoleTypeId) === parseInt(value));
    
    dispatch(setSelectedE9Roles(selectedRole))
})